import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import QueueAnim from "rc-queue-anim";
import { tryNow } from "../../utils";
import { Title } from "../../components/NewTitle";
import { TryOn } from "../../components/TryOn";

export const HomeTryOn = ({ tryOnBtn } = {}) => {
  const { t } = useTranslation();
  return (
    <div className="home-try-on">
      <div className="inner">
        <Title title={t("home.tryOn.title")} size="h1"></Title>
        <div className="descript">{t("home.tryOn.subtitle")}</div>
        {tryOnBtn || <TryOn style={{ justifyContent: "center" }} />}
      </div>
    </div>
  );
};
